// extracted by mini-css-extract-plugin
export default {"pro":"Profile_pro__sZr-O","modal-modal-profile":"Profile_modal-modal-profile__-2tdF"};